module.exports = __webpack_public_path__ + "static/media/womenentrepreneuricon.763fe8ee.svg";